// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_DZE","cls2":"ExportFormatModal-cls2_vCr ExportFormatModal-cls1_DZE"};